export default "__VITE_ASSET__ykJX82vr__"